import type { HostedBusinessOwner } from '@onefootprint/request-types';
import type { NewBusinessOwner } from '../manage-business-owners.types';

/** Returns true if the BO is editable and should be rendered by EditBosForm. If the BO is mutable OR if the ownership stake is not yet set, we will render it in EditBosForm. */
export const isBoEditable = (bo: HostedBusinessOwner) =>
  bo.isMutable || bo.ownershipStake === undefined || bo.ownershipStake === null;

export const getDefaultFormValues = (existingBos: HostedBusinessOwner[]): NewBusinessOwner[] => {
  // First, take all "mutable" BOs from the backend and insert them into the list of default form values.
  // This includes the primary BO during a new business onboarding.
  const defaultBos: NewBusinessOwner[] = existingBos.filter(isBoEditable).map(bo => {
    return {
      uuid: bo.uuid,
      email: bo.decryptedData['id.email'],
      phoneNumber: bo.decryptedData['id.phone_number'],
      // For some fields, overlay bootstrapped data for the primary owner, if available
      firstName: bo.decryptedData['id.first_name'],
      lastName: bo.decryptedData['id.last_name'],
      ownershipStake: bo.ownershipStake,
    };
  });
  return defaultBos;
};
